import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Utils } from 'src/app/common/utils';
import { Location } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { CouponDetails } from 'src/app/models/CouponDetails';
import moment from 'moment';

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: 'app-coupons-edit',
  templateUrl: './coupons-edit.component.html',
  styleUrls: ['./coupons-edit.component.css']
})
export class CouponsEditComponent implements OnInit {

  coupon_id: string;
  currentDate = Utils.maxDate;
  couponDetails: CouponDetails[];
  validFromDate: any = '';
  validToDate: any = '';
  validToMinDate: any = '';

  constructor(
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private service: VproService,
    private utils: Utils,
    private location: Location,
    private _formBuilder: UntypedFormBuilder
  ) { this.coupon_id = this.route.snapshot.params["id"]; }

  couponEditForm: UntypedFormGroup;

  ngOnInit() {
    this.getCouponDetailsById();
    this.couponEditForm = this._formBuilder.group({
      coupon_id: { value: '', disabled: true },
      description: ['', [Validators.required]],
      discount_percent: { value: '', disabled: true },
      valid_from: { value: '', disabled: true },
      valid_to: ['', [Validators.required]],
      scope: { value: '', disabled: true },
    })
  }

  getCouponDetailsById() {
    let queryParam = `?id=${this.coupon_id}`;
    this.spinner.show();
    this.service.fetchCoupons(queryParam).subscribe(res => {
      this.spinner.hide();
      this.couponDetails = res;
      if (this.couponDetails && this.couponDetails.length > 0) {
        /* date in IST for displaying in DatePicker*/
        this.validFromDate = {
          year: moment(this.couponDetails[0].valid_from).year(),
          month: moment(this.couponDetails[0].valid_from).month() + 1,
          day: moment(this.couponDetails[0].valid_from).date()
        };
        /* date in IST for displaying in DatePicker */
        this.validToDate = {
          year: moment(this.couponDetails[0].valid_to).year(),
          month: moment(this.couponDetails[0].valid_to).month() + 1,
          day: moment(this.couponDetails[0].valid_to).date()
        };
        /* DateTime check in UTC Timezone */
        if (moment.utc(this.couponDetails[0].valid_from).isBefore(moment().utc())) {
          this.validToMinDate = this.currentDate;
        }
        else {
          this.validToMinDate = this.validFromDate;
        }
        this.couponEditForm.patchValue({
          coupon_id: this.couponDetails[0].id,
          description: this.couponDetails[0].description,
          discount_percent: this.couponDetails[0].discount_percent,
          valid_from: moment(this.couponDetails[0].valid_from).format('DD/MM/YYYY'), /* IST time for displaying */
          valid_to: this.validToDate,
          scope: this.couponDetails[0].scope,
        });
      }
    }, err => {
      // console.log(err);
      this.spinner.hide();
      this.showToast('error', "Coupon not found");
    })
  }

  couponUpdate() {
    let queryParam = `?check=true`;
    let data = { description: this.couponEditForm.get("description").value };
    let { year: endYear, month: endMonth, day: endDay } = this.couponEditForm.value.valid_to;
    data["valid_to"] = moment((endYear + "-" + endMonth + "-" + endDay), 'YYYY-MM-DD').endOf('day').utc().valueOf();
    this.spinner.show();
    this.service.updateCoupons(this.coupon_id, data, queryParam).subscribe(
      (res) => {
        this.spinner.hide();
        // SweetAlert
        this.showToast('success', "Coupon has been updated successfuly");
      },
      (error) => {
        // console.log(error);
        this.spinner.hide();
        this.showToast('error', `${error.error.message.message}. Couldn't update Coupon.`);
      }
    );
  }

  couponDelete() {
    this.spinner.show();
    this.service.deleteCoupon(this.coupon_id).subscribe(
      (res) => {
        this.spinner.hide();
        // SweetAlert
        this.showToast('success', "Coupon has been deleted successfuly");
        this.location.back();
      },
      (error) => {
        this.spinner.hide();
        this.showToast('error', `${error.error.message.message}. Couldn't delete Coupon.`);
      }
    );
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title:
        title
    });
  }

  getback() {
    this.location.back();
  }

}
